import type {ClientEntitlements} from '@nursio-link/common/authorization';
import {isEntitled} from '@nursio-link/common/authorization';

import {graphqlClient} from '@/services/graphqlClient';
import type {GetEntitlementsQuery} from '@/services/graphqlHooks';
import {useGetEntitlementsQuery} from '@/services/graphqlHooks';
import queryClient from '@/services/queryClient';

export const isCurrentClientEntitle = async (
  clientEntitlements: ClientEntitlements
) => {
  const entitlementsQuery =
    await queryClient.ensureQueryData<GetEntitlementsQuery>({
      queryKey: useGetEntitlementsQuery.getKey(),
      queryFn: () => graphqlClient.request(useGetEntitlementsQuery.document),
    });

  const entitlements = entitlementsQuery.getEntitlements;

  if (!entitlements?.length) return false;
  return isEntitled(entitlements, clientEntitlements);
};

export default isCurrentClientEntitle;
